import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import {
  OtpService,
  OtpState,
  ValidarOtpResponse,
} from '../../services/otp/otp.service';
import {
  FirmaService,
  FirmaSesionResponse,
  FirmaEjecutarRequest,
  FirmaEjecutarResponse,
  FirmaSolicitudResponse,
} from '../../services/firma/firma.service';
import { FileServerService } from '../../services/file-server/file-server.service';
import { EjecutarFirmaElectronicaService } from '../../services/ejecutar-firma/ejecutar-firma.service';
import { EjecutarFirmaRequest } from '../../models/ejecutar-firma/ejecutar-firma';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-firmas',
  templateUrl: './firmas.component.html',
  styleUrls: ['./firmas.component.css'],
})
export class FirmasComponent implements OnInit, OnDestroy {
  token: string = '';
  idEnlaceFirma: number = 0;
  solicitud: FirmaSolicitudResponse | null = null;
  cargandoSesion: boolean = false;
  tokenInvalido: boolean = false;
  cargandoDatos: boolean = false;

  mostrarModal: boolean = true;
  aceptoTerminos: boolean = false;

  mostrarModalDocumento: boolean = false;
  documentoSeleccionado: any = null;
  // urlDocumentoPreview: string = '';
  urlDocumentoPreview: SafeResourceUrl | null = null;

  mostrarSeccionOTP: boolean = false;
  codigoOTP: string = '';
  tiempoRestanteOTP: number = 0;
  intervaloTemporizador: any;

  readonly tiempoVigenciaSegundos: number = 5 * 60;
  readonly maximoIntentosFallidos: number = 3;
  readonly maximoReenvios: number = 5;

  cargandoOTP: boolean = false;
  mostrarModalExito: boolean = false;
  procesandoFirma: boolean = false;
  enlaceYaUtilizado: boolean = false;
  firmaRealizada: boolean = false;

  mostrarModalAlerta: boolean = false;
  tituloAlerta: string = '';
  mensajeAlerta: string = '';

  mostrarModalCaptcha: boolean = false;
  captchaToken: string = '';
  private captchaResolveCallback: ((result: boolean) => void) | null = null;

  datosNavegador: string = '';
  sistemaOperativo: string = '';
  fechaAccesoEnlace: Date = new Date();

  otpState: OtpState = {
    mail: '',
    celular: '',
    otpSolicitado: false,
    tiempoInicio: 0,
    contadorReenvios: 0,
    intentosFallidos: 0,
    otpBloqueado: false,
    otpExpirado: false,
  };

  mensajeFirma: string = `Las partes acuerdan formalizar la presente afiliación a <strong>Coomeva Medicina Prepagada S.A.</strong> mediante firma electrónica a través de la <strong>[Nombre de la aplicación donde se realiza la firma digital]</strong>, medio equivalente funcionalmente y con los mismos efectos legales a la firma manuscrita en papel, cuya validez jurídica se encuentra reconocida en la <strong>Ley 527 de 1999, Decreto 1074 de 2015 y el Código General del Proceso</strong>.
  <br><br>
  La firma electrónica del <strong>CONTRATANTE</strong> será plasmada en cada uno de los siguientes documentos a través de los cuales se formaliza la afiliación a Coomeva Medicina Prepagada S.A. y para todos los efectos legales reconoce haber tenido acceso a los mismos y declara haberlos leído, comprendido y aceptado en su totalidad.`;

  datosSolicitud = {
    numeroSolicitud: '5655',
    tipoSolicitud: 'Novedades de Traslados',
    detalleSolicitud: 'Cambio de Cobertura',
    identificacionContratante: 'CC 123456',
    nombreContratante: 'NOMBRES Y APELLIDOS',
    mail: 'jestebanlondono11@gmail.com',
    celular: '3116542516',
  };

  usuariosATrasladar: Array<{
    no: number;
    identificacion: string;
    nombreUsuario: string;
  }> = [];

  mensajeAviso: string =
    'Según los criterios establecidos por auditoría médica y demás procesos internos, se determinará si la solicitud de traslado es procedente, por lo que la firma electrónica de los documentos no implica la aceptación automática ni garantiza la aplicación del traslado.';

  documentos: Array<{
    codigoDocumento: any;
    nombreDocumento: any;
    idTipoDocumento: any;
    idDocSoporte: any;
    nombre: string;
    url?: string;
    visible: boolean;
    firmado?: boolean;
    fechaFirma?: Date;
    firmante?: string;
    idTransaccion?: string;
  }> = [];

  constructor(
    public dialog: MatDialog,
    private otpService: OtpService,
    private firmaService: FirmaService,
    private route: ActivatedRoute,
    private fileServerService: FileServerService,
    private firmaElectronicaService: EjecutarFirmaElectronicaService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.detectarNavegadorYSO();
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) {
      this.tokenInvalido = true;
      this.mostrarModal = false;
      return;
    }
    this.validarSesion();
  }

  validarSesion(): void {
    this.cargandoSesion = true;
    this.firmaService.validarSesion(this.token).subscribe({
      next: (sesion: FirmaSesionResponse) => {
        this.cargandoSesion = false;
        this.idEnlaceFirma = sesion.idEnlaceFirma;
        if (sesion.estado !== 'ACTIVO') {
          this.enlaceYaUtilizado = true;
          this.mostrarModal = false;
          return;
        }
        if (sesion.firmado) {
          this.firmaRealizada = true;
          this.mostrarModal = false;
        }
        this.cargarDatosSolicitud();
      },
      error: (err: HttpErrorResponse) => {
        this.cargandoSesion = false;
        this.tokenInvalido = true;
        this.mostrarModal = false;
      },
    });
  }

  cargarDatosSolicitud(): void {
    this.cargandoDatos = true;
    this.firmaService.obtenerDatosSolicitud(this.token).subscribe({
      next: (sol: FirmaSolicitudResponse) => {
        this.cargandoDatos = false;
        this.solicitud = sol;
        this.datosSolicitud = {
          numeroSolicitud: String(sol.idSolicitudesRadicadas),
          tipoSolicitud: String(sol.tipoSolicitud ?? ''),
          detalleSolicitud: sol.tipoNovedad || '',
          identificacionContratante: `${sol.contratante.tipoDocumento} ${sol.contratante.nroDocumento}`,
          nombreContratante: sol.contratante.nombreUsuario,
          mail: sol.contratante.correo || '',
          celular: sol.contratante.celular || '',
        };

        const todosParaTabla = sol.contratante ? [sol.contratante, ...sol.integrantes] : sol.integrantes;
        
        this.usuariosATrasladar = todosParaTabla.map((integrante, idx) => ({
          no: idx + 1,
          identificacion: `${integrante.tipoDocumento} - ${integrante.nroDocumento}`,
          nombreUsuario: integrante.nombreUsuario,
        }));
        const todosDocumentos = [
          ...sol.contratante.documentos,
          ...sol.integrantes.flatMap((i) => i.documentos),
        ];
        if (todosDocumentos.length > 0) {
          this.documentos = todosDocumentos.map((doc) => ({
            idDocSoporte: doc.idDocSoporte,
            nombre:
              doc.nombreDocumento ?? doc.rutaArchivo.split('/').pop() ?? '',
            url: doc.rutaArchivo,
            visible: false,
            codigoDocumento: doc.codigoDocumento,
            nombreDocumento: doc.nombreDocumento,
            idTipoDocumento: doc.idTipoDocumento,
          }));
        }
        // this.verificarEnlaceUtilizado();
        if (this.firmaRealizada) {
          this.documentos.forEach((d) => (d.firmado = true));
        }
      },
      error: (err: HttpErrorResponse) => {
        this.cargandoDatos = false;
        if (this.firmaRealizada) return; 
        this.tokenInvalido = true;
        this.mostrarModal = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.detenerTemporizador();
  }

  detectarNavegadorYSO(): void {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf('Chrome') > -1) {
      this.datosNavegador = 'Google Chrome';
    } else if (userAgent.indexOf('Safari') > -1) {
      this.datosNavegador = 'Safari';
    } else if (userAgent.indexOf('Firefox') > -1) {
      this.datosNavegador = 'Mozilla Firefox';
    } else if (userAgent.indexOf('Edge') > -1) {
      this.datosNavegador = 'Microsoft Edge';
    } else {
      this.datosNavegador = 'Navegador desconocido';
    }

    if (userAgent.indexOf('Win') > -1) {
      this.sistemaOperativo = 'Windows';
    } else if (userAgent.indexOf('Mac') > -1) {
      this.sistemaOperativo = 'MacOS';
    } else if (userAgent.indexOf('Linux') > -1) {
      this.sistemaOperativo = 'Linux';
    } else if (userAgent.indexOf('Android') > -1) {
      this.sistemaOperativo = 'Android';
    } else if (userAgent.indexOf('iOS') > -1) {
      this.sistemaOperativo = 'iOS';
    } else {
      this.sistemaOperativo = 'SO desconocido';
    }
  }

  verificarEnlaceUtilizado(): void {
    const enlaceUtilizado = localStorage.getItem(
      `enlace_usado_${this.datosSolicitud.numeroSolicitud}`,
    );
    if (enlaceUtilizado === 'true') {
      this.enlaceYaUtilizado = true;
      this.mostrarModal = false;
    }
  }

  aceptarFirmaInicial(): void {
    this.mostrarModal = false;
  }

  onCheckboxChange(): void {
    if (this.aceptoTerminos) {
      this.llamarGenerarOTP();
    } else {
      this.limpiarSeccionOTP();
    }
  }

  async llamarGenerarOTP(): Promise<void> {
    const { mail, celular } = this.datosSolicitud;

    if (this.otpState.otpBloqueado) {
      this.mostrarAlerta(
        'OTP Bloqueado',
        'La verificación ha sido bloqueada por razones de seguridad. Por favor comunícate con un ejecutivo para reactivar tu solicitud.',
      );
      this.aceptoTerminos = false;
      return;
    }

    if (this.debeMostrarCaptcha()) {
      const captchaValido = await this.mostrarCaptcha();
      if (!captchaValido) {
        this.aceptoTerminos = false;
        return;
      }
    }

    this.cargandoOTP = true;
    this.otpService.generarOtp(mail, celular).subscribe({
      next: () => {
        this.cargandoOTP = false;
        this.otpState = {
          mail: mail.trim(),
          celular: celular.trim(),
          otpSolicitado: true,
          tiempoInicio: Date.now(),
          contadorReenvios: this.otpState.contadorReenvios,
          intentosFallidos: 0,
          otpBloqueado: false,
          otpExpirado: false,
        };
        this.codigoOTP = '';
        this.tiempoRestanteOTP = this.tiempoVigenciaSegundos;
        this.mostrarSeccionOTP = true;
        this.iniciarTemporizador();
      },
      error: (err: HttpErrorResponse) => {
        this.cargandoOTP = false;
        this.aceptoTerminos = false;
        if (err.status === 400 && err.error?.message) {
          this.mostrarAlerta('Error de validación', err.error.message);
        } else if (err.status === 503) {
          this.mostrarAlerta(
            'Servicio no disponible',
            'Servicio temporalmente no disponible. Intente más tarde.',
          );
        } else if (err.status === 0) {
          this.mostrarAlerta(
            'Error de conexión',
            'Error de conexión. Verifique su red e intente de nuevo.',
          );
        } else {
          this.mostrarAlerta(
            'Error',
            'Ha ocurrido un error inesperado. Intente más tarde.',
          );
        }
      },
    });
  }

  iniciarTemporizador(): void {
    this.detenerTemporizador();
    this.intervaloTemporizador = setInterval(() => {
      const transcurrido = Math.floor(
        (Date.now() - this.otpState.tiempoInicio) / 1000,
      );
      this.tiempoRestanteOTP = Math.max(
        0,
        this.tiempoVigenciaSegundos - transcurrido,
      );
      if (this.tiempoRestanteOTP <= 0) {
        this.expirarOTP();
      }
    }, 1000);
  }

  detenerTemporizador(): void {
    if (this.intervaloTemporizador) {
      clearInterval(this.intervaloTemporizador);
      this.intervaloTemporizador = null;
    }
  }

  expirarOTP(): void {
    this.detenerTemporizador();
    this.otpState.otpExpirado = true;
    this.tiempoRestanteOTP = 0;
  }

  limpiarSeccionOTP(): void {
    this.mostrarSeccionOTP = false;
    this.codigoOTP = '';
    this.tiempoRestanteOTP = 0;
    this.detenerTemporizador();
  }

  formatearTiempo(): string {
    const minutos = Math.floor(this.tiempoRestanteOTP / 60);
    const segundos = this.tiempoRestanteOTP % 60;
    return `${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
  }

  validarCaracteres(event: Event): void {
    const input = event.target as HTMLInputElement;

    const valorLimpio = input.value.replace(/[^a-zA-Z0-9]/g, '');

    input.value = valorLimpio;
    this.codigoOTP = valorLimpio;
  }

  validarTeclaOTP(event: KeyboardEvent): void {
    const teclasPermitidas = [
      'Backspace',
      'Delete',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
    ];

    if (teclasPermitidas.includes(event.key)) {
      return;
    }

    if (!/^[a-zA-Z0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  onCodigoOTPChange(): void {
    if (this.codigoOTP.length > 6) {
      this.codigoOTP = this.codigoOTP.substring(0, 6);
    }
  }

  async solicitarNuevoOTP(): Promise<void> {
    if (!this.otpState.otpSolicitado) return;

    if (this.otpState.contadorReenvios >= this.maximoReenvios) {
      this.bloquearOTP();
      return;
    }

    if (this.otpState.contadorReenvios >= 1) {
      const captchaValido = await this.mostrarCaptcha();
      if (!captchaValido) return;
    }

    this.otpState.contadorReenvios++;
    this.otpState.otpExpirado = false;
    this.otpState.intentosFallidos = 0;
    this.cargandoOTP = true;

    this.otpService
      .generarOtp(this.otpState.mail, this.otpState.celular)
      .subscribe({
        next: () => {
          this.cargandoOTP = false;
          this.otpState.tiempoInicio = Date.now();
          this.otpState.otpBloqueado = false;
          this.codigoOTP = '';
          this.tiempoRestanteOTP = this.tiempoVigenciaSegundos;
          this.iniciarTemporizador();
        },
        error: (err: HttpErrorResponse) => {
          this.cargandoOTP = false;
          this.otpState.contadorReenvios = Math.max(
            0,
            this.otpState.contadorReenvios - 1,
          );
          if (err.status === 400 && err.error?.message) {
            this.mostrarAlerta('Error de validación', err.error.message);
          } else if (err.status === 503) {
            this.mostrarAlerta(
              'Servicio no disponible',
              'Servicio temporalmente no disponible. Intente más tarde.',
            );
          } else if (err.status === 0) {
            this.mostrarAlerta(
              'Error de conexión',
              'Error de conexión. Verifique su red e intente de nuevo.',
            );
          } else {
            this.mostrarAlerta(
              'Error',
              'Ha ocurrido un error inesperado. Intente más tarde.',
            );
          }
        },
      });
  }

  firmarDocumentos(): void {
    if (this.firmaRealizada) {
      this.mostrarAlerta(
        'Firma ya realizada',
        'Los documentos ya han sido firmados exitosamente. No puede firmar nuevamente.',
      );
      return;
    }

    if (!this.codigoOTP || !this.codigoOTP.trim()) {
      this.mostrarAlerta('Código requerido', 'Debe ingresar el código OTP.');
      return;
    }

    if (!/^[a-zA-Z0-9]+$/.test(this.codigoOTP)) {
      this.mostrarAlerta(
        'Código inválido',
        'El código no debe contener caracteres especiales.',
      );
      return;
    }

    if (this.otpState.otpBloqueado) {
      this.mostrarAlerta(
        'OTP Bloqueado',
        'La verificación ha sido bloqueada por razones de seguridad. Comunícate con un ejecutivo para reactivar tu solicitud.',
      );
      return;
    }

    if (this.otpState.otpExpirado || this.tiempoRestanteOTP <= 0) {
      this.mostrarAlerta(
        'Código expirado',
        'El código OTP ha expirado. Solicite uno nuevo.',
      );
      return;
    }

    this.procesandoFirma = true;

    this.otpService
      .validarOtp(this.otpState.mail, this.otpState.celular, this.codigoOTP)
      .subscribe({
        next: (response: ValidarOtpResponse) => {
          switch (response.codigoRespuesta) {
            case 0:
              this.detenerTemporizador();
              this.firmaRealizada = true;
              this.ejecutarProcesoFirmaElectronica();
              break;

            case 1:
              this.procesandoFirma = false;
              this.otpState.intentosFallidos++;
              const restantes =
                this.maximoIntentosFallidos - this.otpState.intentosFallidos;
              if (
                this.otpState.intentosFallidos >= this.maximoIntentosFallidos
              ) {
                this.bloquearOTP();
              } else {
                this.mostrarAlerta(
                  'Código incorrecto',
                  `Código incorrecto. Verifica que el número ingresado coincida con el que recibiste. Puedes intentarlo nuevamente.`,
                );
              }
              break;

            case 2:
              this.procesandoFirma = false;
              this.otpState.otpExpirado = true;
              this.detenerTemporizador();
              this.tiempoRestanteOTP = 0;
              this.mostrarAlerta(
                'Código expirado',
                'El código ha expirado. Solicite un nuevo código.',
              );
              break;

            default:
              this.procesandoFirma = false;
              this.mostrarAlerta(
                'Error en servicio',
                'Error en el servicio de verificación. Intente más tarde.',
              );
          }
        },
        error: (err: HttpErrorResponse) => {
          this.procesandoFirma = false;
          if (err.status === 400 && err.error?.message) {
            this.mostrarAlerta('Error de validación', err.error.message);
          } else if (err.status === 503) {
            this.mostrarAlerta(
              'Servicio no disponible',
              'Servicio de verificación no disponible. Intente más tarde.',
            );
          } else if (err.status === 0) {
            this.mostrarAlerta(
              'Error de conexión',
              'Error de conexión. Verifique su red e intente de nuevo.',
            );
          } else {
            this.mostrarAlerta(
              'Error',
              'Ha ocurrido un error inesperado. Intente más tarde.',
            );
          }
        },
      });
  }

  bloquearOTP(): void {
    this.otpState.otpBloqueado = true;
    this.detenerTemporizador();
    this.procesandoFirma = false;
    this.mostrarAlerta(
      'Verificación bloqueada',
      'Tu verificación ha sido bloqueada por razones de seguridad. Por favor comunícate con un ejecutivo para reactivar tu solicitud desde la Bandeja de Gestión.',
    );
  }

  ejecutarProcesoFirma(): void {
    const request: FirmaEjecutarRequest = {
      idEnlaceFirma: this.idEnlaceFirma,
      idSolicitudesRadicadas: this.solicitud?.idSolicitudesRadicadas ?? 0,
      codigoOtp: this.codigoOTP,
      datosNavegador: this.datosNavegador,
      sistemaOperativo: this.sistemaOperativo,
      fechaAccesoEnlace: this.fechaAccesoEnlace.toISOString(),
    };
    this.firmaService.ejecutarFirma(request).subscribe({
      next: (_response: FirmaEjecutarResponse) => {
        this.actualizarDocumentosConFirma();
        this.procesandoFirma = false;
        this.mostrarModalExito = true;
      },
      error: (err: HttpErrorResponse) => {
        this.firmaRealizada = false;
        this.procesandoFirma = false;
        if (err.status === 400 && err.error?.message) {
          this.mostrarAlerta('Error al firmar', err.error.message);
        } else if (err.status === 503) {
          this.mostrarAlerta(
            'Servicio no disponible',
            'No fue posible completar la firma. Intente más tarde.',
          );
        } else if (err.status === 0) {
          this.mostrarAlerta(
            'Error de conexión',
            'Error de conexión. Verifique su red e intente de nuevo.',
          );
        } else {
          this.mostrarAlerta(
            'Error',
            'Ha ocurrido un error al procesar la firma. Intente más tarde.',
          );
        }
      },
    });
  }

  ejecutarProcesoFirmaElectronica(): void {
    const request: EjecutarFirmaRequest = {
      idEnlaceFirma: this.idEnlaceFirma,
      idSolicitudesRadicadas: this.solicitud?.idSolicitudesRadicadas ?? 0,
      codigoOtp: this.codigoOTP,
      datosNavegador: navigator.userAgent,
      sistemaOperativo: navigator.platform,
      fechaAccesoEnlace: this.fechaAccesoEnlace.toISOString(),
      canalFirma: 'CORREO',
      tipoDocumento:
        this.datosSolicitud.identificacionContratante.split(' ')[0],
      numeroDocumento:
        this.datosSolicitud.identificacionContratante.split(' ')[1],
      nombreContratante: this.datosSolicitud.nombreContratante,
      correoContratante: this.datosSolicitud.mail,
      celularContratante: this.datosSolicitud.celular,

      documentos: this.documentos.map((doc) => ({
        idDocSoporte: doc.idDocSoporte,
        rutaArchivo: doc.url,
        codigoDocumento: doc.codigoDocumento,
        nombreDocumento: doc.nombreDocumento,
        idTipoDocumento: doc.idTipoDocumento,
      })),
    };

    this.firmaElectronicaService.ejecutarFirmaElectronica(request).subscribe({
      next: (resp) => {
        this.actualizarDocumentosConFirma();
        // this.cargarDatosSolicitud(this.solicitud?.idSolicitudesRadicadas ?? 0);
        this.procesandoFirma = false;
        this.mostrarModalExito = true;
      },
      error: (err: HttpErrorResponse) => {
        this.firmaRealizada = false;
        this.procesandoFirma = false;
        if (err.status === 400 && err.error?.message) {
          this.mostrarAlerta('Error al firmar', err.error.message);
        } else if (err.status === 503) {
          this.mostrarAlerta(
            'Servicio no disponible',
            'No fue posible completar la firma. Intente más tarde.',
          );
        } else if (err.status === 0) {
          this.mostrarAlerta(
            'Error de conexión',
            'Error de conexión. Verifique su red e intente de nuevo.',
          );
        } else {
          this.mostrarAlerta(
            'Error',
            'Ha ocurrido un error al procesar la firma. Intente más tarde.',
          );
        }
      },
    });
  }

  generarIdTransaccion(): string {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 10000);
    return `TXN-${this.datosSolicitud.numeroSolicitud}-${timestamp}-${random}`;
  }

  actualizarDocumentosConFirma(): void {
    const fechaFirma = new Date();
    const firmante = this.datosSolicitud.nombreContratante;
    const idTransaccion = this.generarIdTransaccion();
    this.documentos.forEach((doc) => {
      doc.firmado = true;
      doc.fechaFirma = fechaFirma;
      doc.firmante = firmante;
      doc.idTransaccion = idTransaccion;
    });
  }

  puedeHabilitarBotonFirmar(): boolean {
    return (
      this.codigoOTP.length > 0 &&
      !this.otpState.otpExpirado &&
      !this.otpState.otpBloqueado &&
      this.tiempoRestanteOTP > 0 &&
      !this.enlaceYaUtilizado &&
      !this.firmaRealizada
    );
  }

  puedeHabilitarBotonReenvio(): boolean {
    return (
      (this.otpState.otpExpirado || this.tiempoRestanteOTP <= 0) &&
      this.otpState.otpSolicitado &&
      this.otpState.contadorReenvios < this.maximoReenvios &&
      !this.otpState.otpBloqueado &&
      !this.enlaceYaUtilizado
    );
  }

  obtenerNumeroReenvios(): number {
    return this.otpState.contadorReenvios;
  }

  verDocumento(index: number): void {
    this.documentoSeleccionado = this.documentos[index];
    this.urlDocumentoPreview = null;

    this.fileServerService
      .descargarArchivo(this.documentoSeleccionado.url)
      .subscribe({
        next: (blob) => {
          const blobUrl = URL.createObjectURL(blob);
          this.urlDocumentoPreview =
            this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

          this.mostrarModalDocumento = true;
        },
        error: () => {
          this.mostrarAlerta(
            'Error al cargar documento',
            'No fue posible cargar el documento.',
          );
        },
      });
  }

  cerrarModalDocumento(): void {
    this.mostrarModalDocumento = false;
    this.documentoSeleccionado = null;
    this.urlDocumentoPreview = '';
  }

  cerrarModalExito(): void {
    this.mostrarModalExito = false;
    // localStorage.setItem(
    //   `enlace_usado_${this.datosSolicitud.numeroSolicitud}`,
    //   'true',
    // );
  }

  cerrarModalEnlaceUsado(): void {
    this.enlaceYaUtilizado = false;
    this.mostrarModal = false;
  }

  mostrarAlerta(titulo: string, mensaje: string): void {
    this.tituloAlerta = titulo;
    this.mensajeAlerta = mensaje;
    this.mostrarModalAlerta = true;
  }

  cerrarModalAlerta(): void {
    this.mostrarModalAlerta = false;
  }

  mostrarCaptcha(): Promise<boolean> {
    this.captchaToken = '';
    return new Promise((resolve) => {
      this.mostrarModalCaptcha = true;
      this.captchaResolveCallback = resolve;
    });
  }

  onCaptchaResuelto(token: string | null): void {
    if (token) {
      this.captchaToken = token;
      this.mostrarModalCaptcha = false;
      if (this.captchaResolveCallback) {
        this.captchaResolveCallback(true);
        this.captchaResolveCallback = null;
      }
    }
  }

  onCaptchaExpirado(): void {
    this.captchaToken = '';
  }

  aceptarCaptcha(): void {
    this.mostrarModalCaptcha = false;
    if (this.captchaResolveCallback) {
      this.captchaResolveCallback(true);
      this.captchaResolveCallback = null;
    }
  }

  cancelarCaptcha(): void {
    this.captchaToken = '';
    this.mostrarModalCaptcha = false;
    if (this.captchaResolveCallback) {
      this.captchaResolveCallback(false);
      this.captchaResolveCallback = null;
    }
  }

  descargarDocumento(): void {
    this.fileServerService
      .descargarArchivo(this.documentoSeleccionado.url)
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  puedeIngresarCodigo(): boolean {
    return (
      this.otpState.otpSolicitado &&
      !this.otpState.otpExpirado &&
      !this.otpState.otpBloqueado &&
      this.tiempoRestanteOTP > 0 &&
      !this.enlaceYaUtilizado
    );
  }

  debeMostrarCaptcha(): boolean {
    if (!navigator.cookieEnabled) return true;
    if (this.otpState.contadorReenvios >= 1) return true;
    return false;
  }

  enmascararMail(mail: string): string {
    if (!mail || !mail.includes('@')) return mail;
    const [usuario, dominio] = mail.split('@');
    return `${usuario.substring(0, 2)}***@${dominio}`;
  }

  enmascararCelular(celular: string): string {
    if (!celular || celular.length < 7) return celular;
    return `${celular.substring(0, 3)}****${celular.substring(7)}`;
  }

  get canalesEnvioMascarado(): string {
    const m = this.otpState.mail || this.datosSolicitud.mail;
    const c = this.otpState.celular || this.datosSolicitud.celular;
    return `${this.enmascararMail(m)} y ${this.enmascararCelular(c)}`;
  }

  obtenerFechaFirmaFormateada(): string {
    if (this.documentos.length > 0 && this.documentos[0].fechaFirma) {
      const fecha = this.documentos[0].fechaFirma;
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const dia = fecha.getDate().toString().padStart(2, '0');
      const horas = fecha.getHours().toString().padStart(2, '0');
      const minutos = fecha.getMinutes().toString().padStart(2, '0');
      const segundos = fecha.getSeconds().toString().padStart(2, '0');
      return `${fecha.getFullYear()}.${mes}.${dia} ${horas}:${minutos}:${segundos} ${this.obtenerZonaHoraria()}`;
    }
    return new Date().toLocaleString('es-CO');
  }

  obtenerZonaHoraria(): string {
    const offset = new Date().getTimezoneOffset();
    const hours = Math.abs(Math.floor(offset / 60));
    const minutes = Math.abs(offset % 60);
    const sign = offset <= 0 ? '+' : '-';
    return `${sign}${hours.toString().padStart(2, '0')}'${minutes.toString().padStart(2, '0')}'`;
  }
}
